<template>
  <div class="lodging-search-bar d-flex justify-content-center align-items-center mx-auto">
    <div class="search-bar-content">
      <div class="search-bar-inputs">
        <div class="date-input-group">
          <CommonDatePicker
            :startingDateValue="startDate"
            :endingDateValue="endDate"
            :startDate="minDate"
            :endDate="maxDate"
            ref="datePicker"
            @periodSelected="selectDates"
          />
        </div>
        <span class="separator">|</span>
        <div class="guest-input-group">
          <div class="input-wrapper">
            <img src="../../images/profil.svg" v-set-alt class="input-icon" />
            <input
              type="text"
              :value="formatGuestDisplay()"
              @click="showGuestInfo = !showGuestInfo"
              placeholder="Nombre de voyageurs"
              class="raleway-reg-p13 person-pad guest-input"
              readonly
              style="background: rgba(255, 255, 255, 0.95); cursor: pointer;"
            />
          </div>
          <Guestinfo
            v-if="showGuestInfo"
            @ageSelected="updateChildAges"
            @increaseChilds="updateChildren"
            @decreaseChilds="updateChildren"
            @increaseAdults="updateAdults"
            @decreaseAdults="updateAdults"
            @closed="handleGuestInfoClose"
            :initialAdults="adults"
            :initialChilds="children"
          />
        </div>
        <div class="search-bar-button">
          <button
            class="hortense-btn-primary search-btn"
            @click="handleSearch"
            :disabled="isSearching"
          >
            {{ searchButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Guestinfo from '../btns/Guestinfo.vue';

export default {
  name: 'LodgingSearchBar',
  components: {
    Guestinfo
  },
  props: {
    redirectTo: {
      type: String,
      default: '/reservation-hotel'
    }
  },
  data() {
    return {
      startDate: null,
      endDate: null,
      adults: 2,
      children: 0,
      showGuestInfo: false,
      isSearching: false,
      currentDate: new Date()
    };
  },
  computed: {
    minDate() {
      return new Date(
        this.currentDate.getFullYear(),
        this.currentDate.getMonth(),
        this.currentDate.getDate()
      );
    },
    maxDate() {
      return new Date(
        this.currentDate.getFullYear() + 1,
        this.currentDate.getMonth(),
        this.currentDate.getDate()
      );
    },
    searchButtonText() {
      return this.isSearching ? 'Recherche...' : 'Rechercher';
    }
  },
  methods: {
    formatGuestDisplay() {
      const adultText = this.adults > 1 ? `${this.adults} Adultes` : `${this.adults} Adulte`;
      const childText = this.children > 1 ? `${this.children} Enfants` : `${this.children} Enfant`;
      return `${adultText} - ${childText}`;
    },
    handleGuestInfoClose() {
      this.showGuestInfo = false;
    },
    updateAdults(count) {
      this.adults = count;
      this.updateCacheState();
    },
    updateChildren(count) {
      this.children = count;
      this.updateCacheState();
    },
    updateChildAges(ages) {
      // Handle child ages if needed
      console.log('Child ages updated:', ages);
    },
    selectDates(event, start, end) {
      this.startDate = start;
      this.endDate = end;

      if (!start || !end) {
        localStorage.removeItem('reservationState');
        return;
      }
      this.updateCacheState();
    },
    formatDate(date) {
      if (!date) return '';
      const set = new Date(date);
      const options = { year: "numeric", month: "numeric", day: "numeric" };
      return set.toLocaleString("fr", options);
    },
    formatDateKoedia(date) {
      if (!date) return '';
      if (typeof date === 'string' && (date.includes('-') || !date)) {
        return date;
      }
      const dateStr = this.formatDate(date);
      const dateBits = dateStr.split('/');
      return `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}`;
    },
    updateCacheState() {
      const state = {
        koediaFrom: this.formatDateKoedia(this.startDate),
        koediaTo: this.formatDateKoedia(this.endDate),
        from: this.formatDateKoedia(this.startDate),
        to: this.formatDateKoedia(this.endDate),
        adults: this.adults,
        childs: this.children,
      };
      localStorage.setItem('reservationState', JSON.stringify(state));
    },
    handleSearch() {
      if (!this.startDate || !this.endDate) {
        alert('Veuillez sélectionner des dates');
        return;
      }
      
      this.isSearching = true;
      this.updateCacheState();
      
      // Redirect to reservation-hotel page
      setTimeout(() => {
        window.location.href = this.redirectTo;
      }, 500);
    }
  }
};
</script>

<style scoped>
.lodging-search-bar {
  background: white;
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  width: 65%;
  z-index: 1;
  position: relative;
  transform: translateY(-50%);
}

.search-bar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  gap: 20px;
  width: 100%;
}

.search-bar-inputs {
  display: flex;
  align-items: center;
  gap: 3rem;
  flex: 1;
  justify-content: center;

  .separator {
    color: grey;
    margin: 0 1rem;
  }
}

.date-input-group {
  flex-shrink: 0;
}

.guest-input-group {
  flex-shrink: 0;
  position: relative;
}

.input-wrapper {
  position: relative;
  display: inline-block;
}

.input-icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  pointer-events: none;
}

.person-pad {
  padding-left: 40px;
}

.guest-input {
  width: 220px;
  padding: 12px 40px 12px 40px;
  border: none;
  border-radius: 6px;
  font-family: 'Raleway', sans-serif;
  font-size: 14px;
}

.search-bar-button {
  flex-shrink: 0;
}

.search-btn {
  padding: 12px 24px;
  white-space: nowrap;
  min-width: 180px;
}

/* Guest info dropdown positioning */
.guest-input-group #guest-info {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1000;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-top: 5px;
  min-width: 400px;
}

.guest-input-group .container-guest {
  padding-top: 10px;
  margin-top: 2rem;
}

@media (max-width: 768px) {
  .lodging-search-bar {
    display: none;
  }
  
  .guest-input-group #guest-info {
    right: -50px;
    min-width: 280px;
  }
}
</style>